import * as React from 'react'
import { Suspense } from 'react'
import { makeArr } from '@app/utils/helpers'

// Context
import { SubmissionProvider } from '@app/context/SubmissionProvider'

const withProvider = (Component: React.SFC<{}>) => (props: WithProvider.IProps) => {
  const { config } = props
  const dataset = makeArr(config.dataset)

  const providers: any = {
    submission: SubmissionProvider,
  }

  const getProvider = (i: number) => {
    return providers[dataset[i]]
  }

  const wrap = (i: number) => {
    const Wrap: any = getProvider(i)
    return <Wrap config={config}>{dataset[i + 1] ? wrap(i + 1) : <Component {...props} />}</Wrap>
  }

  return <Suspense fallback={null}>{wrap(0)}</Suspense>
}

export default withProvider
